export default {
  SET_PLATFORM_NOTIFICATIONS: (state, platformNotifications) => (state.platformNotifications = platformNotifications),
}
